import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { MainPage } from "../pages/mainPage";
import { PaineldeControle } from "../pages/kpi/dashboard/paineldecontrole";
import { Login } from "../pages/login/login";
import { Empresa } from "../pages/cadastro/empresa/empresa";
import { EmpresaIncluir } from "../pages/cadastro/empresa/empresaIncluir";
import { EmpresaEditar } from "../pages/cadastro/empresa/empresaEditar";
import { EmpresaVisualizar } from "../pages/cadastro/empresa/empresaVisualizar";
import { Usuario } from "../pages/cadastro/usuario/usuario";
import { UsuarioIncluir } from "../pages/cadastro/usuario/usuarioIncluir";
import { UsuarioEditar } from "../pages/cadastro/usuario/usuarioEditar";
import { UsuarioVisualizar } from "../pages/cadastro/usuario/usuarioVisualizar";
import { CodigiodoSistema } from "../pages/cadastro/codigodoSistema/codigodosistema";
import { CodigiodoSistemaIncluir } from "../pages/cadastro/codigodoSistema/codigodosistemaIncluir";
import { CodigiodoSistemaVisualizar } from "../pages/cadastro/codigodoSistema/codigodosistemaVisualizar";
import { CodigiodoSistemaEditar } from "../pages/cadastro/codigodoSistema/codigodosistemaEditar";
import { Agente } from "../pages/cadastro/agente/agente";
import { AgenteIncluir } from "../pages/cadastro/agente/agenteIncluir";
import { AgenteVisualizar } from "../pages/cadastro/agente/agenteVisualizar";
import { AgenteEditar } from "../pages/cadastro/agente/agenteEditar";
import { Ticket } from "../pages/cadastro/ticket/ticket";
import { TicketIncluir } from "../pages/cadastro/ticket/ticketIncluir";
import { TicketVisualizar } from "../pages/cadastro/ticket/ticketVisualizar";
import { TicketEditar } from "../pages/cadastro/ticket/ticketEditar";
import { PrimeiroAcesso } from '../pages/primeiro-acesso';
import { RedefinirSenha } from '../pages/redefinir-senha';
import PaginaNotificacoes from "../pages/Notificacoes";

export default function Rotas(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/primeiro-acesso" element={<PrimeiroAcesso />} />
      <Route path="/redefinir-senha" element={<RedefinirSenha />} />
      
      <Route path="/" element={<MainPage />}>
        
        {/* Cadastro -> Empresa */}
        <Route path="cadastro/empresa" element={<Empresa />} />
        <Route path="cadastro/empresa/:id" element={<EmpresaIncluir />} />
        <Route path="cadastro/empresa/visu/:id" element={<EmpresaVisualizar />} />
        <Route path="cadastro/empresa/editar/:id" element={<EmpresaEditar />} />
        
        {/* Cadastro -> Usuário */}
        <Route path="cadastro/usuario" element={<Usuario />} />
        <Route path="cadastro/usuario/:id" element={<UsuarioIncluir />} />
        <Route path="cadastro/usuario/visu/:id" element={<UsuarioVisualizar />} />
        <Route path="cadastro/usuario/editar/:id" element={<UsuarioEditar />} />
        
        {/* Cadastro -> Códigos dos Sistemas */}
        <Route path="cadastro/codigodosistema" element={<CodigiodoSistema />} />
        <Route path="cadastro/codigodosistema/:id" element={<CodigiodoSistemaIncluir />} />
        <Route path="cadastro/codigodosistema/visu/:id" element={<CodigiodoSistemaVisualizar />} />
        <Route path="cadastro/codigodosistema/editar/:id" element={<CodigiodoSistemaEditar />} />

        {/* Cadastro -> Agentes */}
        <Route path="cadastro/agentes" element={<Agente />} />
        <Route path="cadastro/agentes/:id" element={<AgenteIncluir />} />
        <Route path="cadastro/agentes/visu/:id" element={<AgenteVisualizar />} />
        <Route path="cadastro/agentes/editar/:id" element={<AgenteEditar />} />

        {/* Tickets */}
        <Route path="tickets" element={<Ticket />} />
        <Route path="tickets/:id" element={<TicketIncluir />} />
        <Route path="tickets/visu/:id" element={<TicketVisualizar />} />
        <Route path="tickets/editar/:id" element={<TicketEditar />} />

        {/* Notificações */}
        <Route path="notificacoes" element={<PaginaNotificacoes />} />

        {/* KPI -> Dashboard */}
        <Route path="kpi/dashboard/paineldecontrole" element={<PaineldeControle />} />

        {/* Redirecionar a rota raiz para o painel de controle */}
        <Route index element={<Navigate to="/kpi/dashboard/paineldecontrole" replace />} />
      </Route>
      
      {/* Redirecionar qualquer rota não encontrada para o painel de controle */}
      <Route path="*" element={<Navigate to="/kpi/dashboard/paineldecontrole" replace />} />
    </Routes>
  );
}
